/*
  src/redux/entities/constants.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

function createConstant(action){
  return ['portal', 'entities', action].join('/');
}


export const NO_OP = createConstant('NO_OP');
export const ENTITY_BATCH_REQUESTED = createConstant('ENTITY_BATCH_REQUESTED');
export const ENTITY_BATCH_LOADED = createConstant('ENTITY_BATCH_LOADED');
export const ENTITY_BATCH_FAILED_TO_LOAD = createConstant('ENTITY_BATCH_FAILED_TO_LOAD');
export const LIST_REQUESTED = createConstant('LIST_REQUESTED');
export const LIST_LOADED = createConstant('LIST_LOADED');
export const LIST_FAILED_TO_LOAD = createConstant('LIST_FAILED_TO_LOAD');
export const ENTITY_UPDATE_REQUESTED = createConstant('ENTITY_UPDATE_REQUESTED');
export const ENTITY_UPDATED = createConstant('ENTITY_UPDATED');
export const ENTITY_FAILED_TO_UPDATE = createConstant('ENTITY_FAILED_TO_UPDATE');
export const ENTITY_REQUESTED = createConstant('ENTITY_REQUESTED');
export const ENTITY_LOADED = createConstant('ENTITY_LOADED');
export const ACTIVE_USER_LOADED = createConstant('ACTIVE_USER_LOADED');
export const IMPERSONATED_USER_LOADED = createConstant('IMPERSONATED_USER_LOADED');
export const ENTITY_FAILED_TO_LOAD = createConstant('ENTITY_FAILED_TO_LOAD');
export const ENTITY_CREATE_REQUESTED = createConstant('ENTITY_CREATE_REQUESTED');
export const ENTITY_CREATED = createConstant('ENTITY_CREATED');
export const ENTITY_FAILED_TO_CREATE = createConstant('ENTITY_FAILED_TO_CREATE');
export const REDEMPTION_REQUESTED = createConstant('REDEMPTION_REQUESTED');
export const REDEPTION_COMPLETED = createConstant('REDEPTION_COMPLETED');
export const REDEMPTION_FAILED = createConstant('REDEMPTION_FAILED');
export const USER_REPORT_REQUESTED = createConstant('USER_REPORT_REQUESTED');
export const USER_REPORT_LOADED = createConstant('USER_REPORT_LOADED');
export const USER_REPORT_FAILED_TO_LOAD = createConstant('USER_REPORT_FAILED_TO_LOAD');
export const ENTITY_DELETE_REQUESTED = createConstant('ENTITY_DELETE_REQUESTED');
export const ENTITY_DELETED = createConstant('ENTITY_DELETED');
export const ENTITY_FAILED_TO_DELETE = createConstant('ENTITY_FAILED_TO_DELETE');
export const ENTITY_DUPLICATE_REQUESTED = createConstant('ENTITY_DUPLICATE_REQUESTED');
export const ENTITY_DUPLICATED = createConstant('ENTITY_DUPLICATED');
export const ENTITY_FAILED_TO_DUPLICATE = createConstant('ENTITY_FAILED_TO_DUPLICATE');
export const ENTITY_EXTEND_REQUESTED = createConstant('ENTITY_EXTEND_REQUESTED');
export const ENTITY_EXTENDED = createConstant('ENTITY_EXTENDED');
export const ENTITY_FAILED_TO_EXTEND = createConstant('ENTITY_FAILED_TO_EXTEND');
export const ENTITY_EXISTS = createConstant('ENTITY_EXISTS');
export const ENTITY_PUBLISHERS_UPDATE_REQUESTED = createConstant('ENTITY_PUBLISHERS_UPDATE_REQUESTED');
export const ENTITY_PUBLISHERS_UPDATED = createConstant('ENTITY_PUBLISHERS_UPDATED');
export const ENGAGEMENT_OPTION_CREATE_REQUESTED = createConstant('ENGAGEMENT_OPTION_CREATE_REQUESTED');
export const ENGAGEMENT_OPTION_CREATED = createConstant('ENGAGEMENT_OPTION_CREATED');
export const ENGAGEMENT_OPTION_FAILED_TO_CREATE = createConstant('ENGAGEMENT_OPTION_FAILED_TO_CREATE');
export const ENGAGEMENT_OPTIONS_UPDATE_REQUESTED = createConstant('ENGAGEMENT_OPTIONS_UPDATE_REQUESTED');
export const ENGAGEMENT_OPTION_UPDATE_REQUESTED = createConstant('ENGAGEMENT_OPTION_UPDATE_REQUESTED');
export const ENGAGEMENT_OPTION_UPDATED = createConstant('ENGAGEMENT_OPTION_UPDATED');
export const ENGAGEMENT_OPTIONS_UPDATED = createConstant('ENGAGEMENT_OPTIONS_UPDATED');
export const ENGAGEMENT_OPTION_FAILED_TO_UPDATE = createConstant('ENGAGEMENT_OPTION_FAILED_TO_UPDATE');
export const ENGAGEMENT_OPTIONS_FAILED_TO_UPDATE = createConstant('ENGAGEMENT_OPTIONS_FAILED_TO_UPDATE');
export const ENGAGEMENT_OPTION_DELETE_REQUESTED = createConstant('ENGAGEMENT_OPTION_DELETE_REQUESTED');
export const ENGAGEMENT_OPTION_DELETED = createConstant('ENGAGEMENT_OPTION_DELETED');
export const ENGAGEMENT_OPTION_FAILED_TO_DELETE = createConstant('ENGAGEMENT_OPTION_FAILED_TO_DELETE');
export const ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED = createConstant('ENGAGEMENT_SORT_ORDER_UPDATE_REQUESTED');
export const ENGAGEMENT_SORT_ORDER_UPDATED = createConstant('ENGAGEMENT_SORT_ORDER_UPDATED');
export const ENGAGEMENT_SORT_ORDER_UPDATE_FAILED = createConstant('ENGAGEMENT_SORT_ORDER_UPDATE_FAILED');
export const LOYALTY_BALANCE_REQUESTED = createConstant('LOYALTY_BALANCE_REQUESTED');
export const LOYALTY_BALANCE_LOADED = createConstant('LOYALTY_BALANCE_LOADED');
export const LOYALTY_BALANCE_FAILED_TO_LOAD = createConstant('LOYALTY_BALANCE_FAILED_TO_LOAD');
export const LOYALTY_BALANCE_ADJUSTMENT_REQUESTED = createConstant('LOYALTY_BALANCE_ADJUSTMENT_REQUESTED');
export const LOYALTY_BALANCE_ADJUSTED = createConstant('LOYALTY_BALANCE_ADJUSTED');
export const LOYALTY_BALANCE_ADJUSTMENT_FAILED = createConstant('LOYALTY_BALANCE_UPDATE_FAILED');
export const SET_APPROVED_RETAILERS_REQUESTED = createConstant('SET_APPROVED_RETAILERS_REQUESTED');
export const APPROVED_RETAILERS_SET = createConstant('APPROVED_RETAILERS_SET');
export const SET_APPROVED_RETAILERS_FAILED = createConstant('SET_APPROVED_RETAILERS_FAILED');
export const ENTITY_VALIDATION_REQUESTED = createConstant('ENTITY_VALIDATION_REQUESTED');
export const ENTITY_VALIDATED = createConstant('ENTITY_VALIDATED');
export const ENTITY_FAILED_TO_VALIDATE = createConstant('ENTITY_FAILED_TO_VALIDATE');
export const ENTITY_TAGS_SYNC_REQUESTED = createConstant('ENTITY_TAGS_SYNC_REQUESTED');
export const ENTITY_TAGS_SYNCED = createConstant('ENTITY_TAGS_SYNCED');
export const ENTITY_TAGS_SYNC_FAILED = createConstant('ENTITY_TAGS_SYNC_FAILED');
export const ENTITY_HISTORY_REQUESTED = createConstant('ENTITY_HISTORY_REQUESTED');
export const ENTITY_HISTORY_LOADED = createConstant('ENTITY_HISTORY_LOADED');
export const ENTITY_HISTORY_FAILED_TO_LOAD = createConstant('ENTITY_HISTORY_FAILED_TO_LOAD');
export const ENTITY_GEOFILTER_SYNC_REQUESTED = createConstant('ENTITY_GEOFILTER_SYNC_REQUESTED');
export const ENTITY_GEOFILTER_SYNCED = createConstant('ENTITY_GEOFILTER_SYNCED');
export const ENTITY_GEOFILTER_SYNC_FAILED = createConstant('ENTITY_GEOFILTER_SYNC_FAILED');
export const ENTITY_CONSTRAINTS_SYNC_REQUESTED = createConstant('ENTITY_CONSTRAINTS_SYNC_REQUESTED');
export const ENTITY_CONSTRAINTS_SYNCED = createConstant('ENTITY_CONSTRAINTS_SYNCED');
export const ENTITY_CONSTRAINTS_SYNC_FAILED = createConstant('ENTITY_CONSTRAINTS_SYNC_FAILED');



// WEBPACK FOOTER //
// ./src/shared/redux/entities/constants.js